import apiRequest from './index'

export default {
  async get (authid, ssCode) {
    await window.callNativeHTTPX()
    return apiRequest.get(`/v1/carwash/ss/${ssCode}/prepaidCards/charge/usedHistory`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'APP-USERS-AUTH-ID': authid
      }
    })
  }
}
